import script from "./cascade-superior-link-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./cascade-superior-link-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./cascade-superior-link-dialog.vue?vue&type=style&index=0&id=4dc9a72d&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc9a72d"]])

export default __exports__